import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import apiCalls from "../../utils/apiCalls";
import utils from "../../utils/utils";
import {injectIntl} from "react-intl";

const AdminChefRow = ({chef, getChefs, intl}) => {
  const avatar = chef.image? <img src={chef.image.thumbnailImage} alt={chef.name + ' avatar'}/>: '';

  function deleteChef() {
    const confirmMessage = intl.formatMessage({id: 'chef.view.delete.confirm'});

    if (window.confirm(confirmMessage)) {
      apiCalls.deleteChef(chef.id)
        .then(() => {
          getChefs();
        }).catch((errors) => {
        window.alert(utils.getErrorMessageFromResponse(errors, true));
      });
    }
  }
  
  return (
    <tr>
      <th scope="row">
        <Link to={`/admin/chefs/${chef.id}`} className="link">
          {chef.id}
        </Link>
      </th>
      <td className="admin-user__image">
        <Link to={`/admin/chefs/${chef.id}`}>
          {avatar}
        </Link>
      </td>
      <td>
        {chef.name}
      </td>
      <td>
        {chef.description}
      </td>
      <td>
        <Link to={`/admin/chefs/edit/${chef.id}`} className="link">
          Edit
        </Link><br/>
        <button className="btn btn-normal-link" onClick={deleteChef}>Delete</button><br/>
      </td>
    </tr>
  );
}

AdminChefRow.propTypes = {
  chef: PropTypes.object.isRequired,
  getChefs: PropTypes.func.isRequired,
};

AdminChefRow.defaultProps = {};

export default injectIntl(AdminChefRow);